<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 1.tabbar-container-start -->
    <tabbar
      :goodsNumber="goodsNumber"
      :tabbarIndex="9"
      :tabbarShow="false"
    ></tabbar>
    <!-- 1.tabbar-container-end -->

    <!-- 2.main-container-start -->
    <div class="main-container">
      <!-- 2.1.购车商品 -->
      <c-car
        @deteleSuccess="deteleSuccess"
        @changeStep="changeStep"
        v-if="step == 1"
      ></c-car>
      <!-- 2.1.购车商品 -->
      <!-- 2.2.填写收货地址 -->
      <c-address
        @changeStep="changeStep2"
        :shoppingCar="shoppingCar"
        v-else-if="step == 2"
      ></c-address>
      <!-- 2.2.填写收货地址 -->
    </div>
    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer></c-footer>
    <!-- 100.footer-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
import car from "./components/car";
import address from "./components/address";
import { shoppingCarNumber } from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      btns: [
        // 1.1.buttons
        { name: "个人信息", id: 1 },
        { name: "修改密码", id: 2 },
      ],

      step: 1, // 1.2.购物步骤1购物车2填写地址
      shoppingCar: [], // 1.3.购物车商品信息
      goodsNumber: 0, // 1.4.购物车商品数量
    };
  },

  components: {
    // 2.components
    tabbar, // 2.1.页面顶部部分
    cFooter: footer, // 2.2.页面底部
    cCar: car, // 2.3.中间购物车车部分
    cAddress: address, // 2.4.中间填写收货地址
  },

  methods: {
    // 3.methods
    changeStep(shoppingCar) {
      this.step = 2;
      this.shoppingCar = shoppingCar;
    },

    changeStep2(shoppingCar) {
      this.step = 1;
      this.shoppingCar = shoppingCar;
    },

    getGoodsNumber() {
      // 3.3.获取购物车信息
      shoppingCarNumber().then((res) => {
        if (res) {
          this.goodsNumber = res.data;
        }
      });
    },

    deteleSuccess() {
      // 3.4.删除成功要
      this.getGoodsNumber();
    },
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getGoodsNumber(); // 4.1.获取商品数量
    }
  },
};
</script>

<style scoped lang="scss">
@import "./shoppingCar.scss";
</style>
